import { API_URL, doApiGet } from '../services/apiService'
import {
  extractUrlInfo,
  findMainFamilyHead,
  findPersonByRelation,
} from './familyUtils'

export const fetchFamilyData = async (
  location,
  isMainSite,
  currentFamilyHead,
  setCurrentFamilyHead,
  setPathPrefix,
  setFamilyHeadsBazach,
  setFamilyHeadsHumenir,
  setLoading,
  setIsInitialized,
  setError,
  setIsMainSite,
  i18n,
  pathPrefix
) => {
  try {
    const data = await doApiGet(`${API_URL}/bazach-fathers`)
    const { fetchedAncestorsBazach, fetchedAncestorsHuminer } = data
    setFamilyHeadsBazach(fetchedAncestorsBazach)
    setFamilyHeadsHumenir(fetchedAncestorsHuminer)
    handlePathChangeHelper(
      location,
      isMainSite,
      currentFamilyHead,
      setCurrentFamilyHead,
      setPathPrefix,
      setIsMainSite,
      fetchedAncestorsBazach,
      fetchedAncestorsHuminer,
      i18n,
        pathPrefix
    )
    setLoading(false)
    setIsInitialized(true)
  } catch (err) {
    setError('שגיאה בטעינת נתוני המשפחה')
    console.error(err)
    setLoading(false)
    setIsInitialized(true)
  }
}
export const handlePathChangeHelper = (
  location,
  isMainSite,
  currentFamilyHead,
  setCurrentFamilyHead,
  setPathPrefix,
  setIsMainSite,
  familyHeadsBazach,
  familyHeadsHumenir,
  i18n,
  pathPrefix
) => {
  let { language, isHuminer, mainFamily, subFamily } = extractUrlInfo(
    location.pathname,
  )
    const isLanguage =  (language === "he" || language === "en")
  const newSite = isHuminer ? 'huminer' : 'bazach'
  if (newSite !== isMainSite) {
    setIsMainSite(newSite)
  }
  const heads = isHuminer ? familyHeadsHumenir : familyHeadsBazach
  let familyHead = findMainFamilyHead(heads)
  let newPathPrefix

   const newPrefix = pathPrefix.split('/')
  if (language !== newPrefix[1]) {
    if(language !== i18n.language) {
        i18n.changeLanguage(language)
    }
    newPrefix[1] = language
    newPathPrefix = newPrefix.join('/')
  }

  const sub = isHuminer ? subFamily : mainFamily
  const matchingFamilyHead = sub ? findPersonByRelation(heads, sub) : null
    if(matchingFamilyHead && isLanguage) {
        familyHead = matchingFamilyHead
    }
  if (isHuminer && isLanguage) {
      if(!matchingFamilyHead){
        newPathPrefix = `/${language}/huminer/`
      }
      else
    newPathPrefix = `/${language}/huminer/${matchingFamilyHead.nickname}/`
  } else if (isLanguage) {
        if(!matchingFamilyHead){
            newPathPrefix = `/${language}/`
        }
        else
    newPathPrefix = `/${language}/${matchingFamilyHead.nickname}/`
  }
if(currentFamilyHead?.name !== familyHead.name)  setCurrentFamilyHead(familyHead)
  if(newPathPrefix && pathPrefix !== newPathPrefix) setPathPrefix(newPathPrefix)

}
